/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Stat_YearsInputs */

const en_home_stat_years = /** @type {(inputs: Home_Stat_YearsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Years Teaching`)
};

const es_home_stat_years = /** @type {(inputs: Home_Stat_YearsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Años enseñando`)
};

const de_home_stat_years = /** @type {(inputs: Home_Stat_YearsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jahre Unterricht`)
};

const zh_home_stat_years = /** @type {(inputs: Home_Stat_YearsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`教学年限`)
};

const ar_home_stat_years = /** @type {(inputs: Home_Stat_YearsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`سنوات التعليم`)
};

const fr_home_stat_years = /** @type {(inputs: Home_Stat_YearsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Années d'enseignement`)
};

const vi_home_stat_years = /** @type {(inputs: Home_Stat_YearsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Năm giảng dạy`)
};

const sw_home_stat_years = /** @type {(inputs: Home_Stat_YearsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Miaka ya Kufundisha`)
};

const th_home_stat_years = /** @type {(inputs: Home_Stat_YearsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ปีแห่งการสอน`)
};

const bs_home_stat_years = /** @type {(inputs: Home_Stat_YearsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Godina poučavanja`)
};

const ja_home_stat_years = /** @type {(inputs: Home_Stat_YearsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`年の指導歴`)
};

const ko_home_stat_years = /** @type {(inputs: Home_Stat_YearsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`년 레슨 경력`)
};

const pt_home_stat_years = /** @type {(inputs: Home_Stat_YearsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anos de ensino`)
};

const it_home_stat_years = /** @type {(inputs: Home_Stat_YearsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anni di insegnamento`)
};

const sv_home_stat_years = /** @type {(inputs: Home_Stat_YearsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Års undervisning`)
};

const nl_home_stat_years = /** @type {(inputs: Home_Stat_YearsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jaar lesgeven`)
};

const da_home_stat_years = /** @type {(inputs: Home_Stat_YearsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Års undervisning`)
};

const nb_home_stat_years = /** @type {(inputs: Home_Stat_YearsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Års undervisning`)
};

const fi_home_stat_years = /** @type {(inputs: Home_Stat_YearsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vuotta opettajana`)
};

const pl_home_stat_years = /** @type {(inputs: Home_Stat_YearsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lata nauczania`)
};

const ru_home_stat_years = /** @type {(inputs: Home_Stat_YearsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Лет преподавания`)
};

const tr_home_stat_years = /** @type {(inputs: Home_Stat_YearsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yıllık Eğitmenlik Deneyimi`)
};

const hi_home_stat_years = /** @type {(inputs: Home_Stat_YearsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वर्षों का शिक्षण अनुभव`)
};

const id_home_stat_years = /** @type {(inputs: Home_Stat_YearsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tahun Mengajar`)
};

const ms_home_stat_years = /** @type {(inputs: Home_Stat_YearsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tahun Mengajar`)
};

const cs_home_stat_years = /** @type {(inputs: Home_Stat_YearsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Let výuky`)
};

const el_home_stat_years = /** @type {(inputs: Home_Stat_YearsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Χρόνια διδασκαλίας`)
};

const he_home_stat_years = /** @type {(inputs: Home_Stat_YearsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`שנות הוראה`)
};

const af_home_stat_years = /** @type {(inputs: Home_Stat_YearsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jare se onderrig`)
};

const hu_home_stat_years = /** @type {(inputs: Home_Stat_YearsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Év oktatói munka`)
};

/**
* | output |
* | --- |
* | "Years Teaching" |
*
* @param {Home_Stat_YearsInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const home_stat_years = /** @type {((inputs?: Home_Stat_YearsInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Stat_YearsInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_home_stat_years(inputs)
	if (locale === "de") return de_home_stat_years(inputs)
	if (locale === "zh") return zh_home_stat_years(inputs)
	if (locale === "ar") return ar_home_stat_years(inputs)
	if (locale === "fr") return fr_home_stat_years(inputs)
	if (locale === "vi") return vi_home_stat_years(inputs)
	if (locale === "sw") return sw_home_stat_years(inputs)
	if (locale === "th") return th_home_stat_years(inputs)
	if (locale === "bs") return bs_home_stat_years(inputs)
	if (locale === "ja") return ja_home_stat_years(inputs)
	if (locale === "ko") return ko_home_stat_years(inputs)
	if (locale === "pt") return pt_home_stat_years(inputs)
	if (locale === "it") return it_home_stat_years(inputs)
	if (locale === "sv") return sv_home_stat_years(inputs)
	if (locale === "nl") return nl_home_stat_years(inputs)
	if (locale === "da") return da_home_stat_years(inputs)
	if (locale === "nb") return nb_home_stat_years(inputs)
	if (locale === "fi") return fi_home_stat_years(inputs)
	if (locale === "pl") return pl_home_stat_years(inputs)
	if (locale === "ru") return ru_home_stat_years(inputs)
	if (locale === "tr") return tr_home_stat_years(inputs)
	if (locale === "hi") return hi_home_stat_years(inputs)
	if (locale === "id") return id_home_stat_years(inputs)
	if (locale === "ms") return ms_home_stat_years(inputs)
	if (locale === "cs") return cs_home_stat_years(inputs)
	if (locale === "el") return el_home_stat_years(inputs)
	if (locale === "he") return he_home_stat_years(inputs)
	if (locale === "af") return af_home_stat_years(inputs)
	if (locale === "hu") return hu_home_stat_years(inputs)
	return en_home_stat_years(inputs)
});